import { getCellIndex, getCellsArray, isCellSpaned, isRangeId } from "../helpers/main";
import { IAction, IActionConfig, ISpan } from "../types";
import { awaitRedraw } from "@dhx/ts-common/dom";

export class Unmerge implements IAction {
	public config: IActionConfig;
	private _prevSpan: ISpan | undefined;

	constructor(config: IActionConfig) {
		this.config = config;
	}

	do() {
		const { cell, spreadsheet, page , grid} = this.config;
		if (!cell || cell?.includes(",")) return;
		const { merged } = page?.getMeta();
		const cells = getCellsArray(cell as string, grid);
		this._prevSpan = isCellSpaned(cells[0], merged, grid);
		if (!this._prevSpan) return; // return if cell wasn't spaned
		const newMerge: ISpan[] = merged.filter(s => s !== this._prevSpan);
		const scroll = grid?.getScrollState();
		page?.setMeta({ merged: newMerge, scroll });
		(spreadsheet as any)._updateGridState();
	}

	undo() {
		const { page, spreadsheet, grid } = this.config;
		if (!this._prevSpan) return;
		const { merged } = page?.getMeta();
		const scroll = grid?.getScrollState();
		page?.setMeta({scroll, merged: [...merged, this._prevSpan] });
		awaitRedraw().then(() => {
			(spreadsheet as any)._updateGridState();
		});
	}
}
